<template>
  <b-row>
    <b-col>
      <b-card no-body>
        <b-card-header>
          <b-card-title>Checklist</b-card-title>
        </b-card-header>
        <b-card-body>
          <b-nav tabs>
            <b-nav-item 
              v-for="(i,index) in filters.filter(f => f.show)" 
              :key="index"
              :active="i.label == status" 
              @click="status = i.label"
            >
              <font-awesome-icon :icon="i.icon" /> {{ i.label }}
            </b-nav-item>
          </b-nav>
        </b-card-body>
        
        <b-card-body>
          <calendar-view 
            v-if="isPlanningTabSelected" 
            id="calendar"
            ref="calendarView"
            :events="planningItems"
            :show-date="showDate"
            :class="themeClasses"
            :display-period-uom="calenderOptions.displayPeriod" 
            :starting-day-of-week="1" 
            :display-period-count="calenderOptions.displayPeriodCount"
          >
            <template #header="{ headerProps }">
              <!-- <pre class="text-white">{{ headerProps }}</pre> -->
              
              <b-button-toolbar>
                <b-button-group>
                  <b-button @click="addDateWeek(-4)">
                    <font-awesome-icon icon="angle-double-left" /> 
                  </b-button>
                  <b-button @click="addDateWeek(-1)">
                    <font-awesome-icon icon="angle-left" /> 
                  </b-button>
                  <b-button @click="addDateWeek(1)">
                    <font-awesome-icon icon="angle-right" />
                  </b-button>
                  <b-button @click="addDateWeek(4)">
                    <font-awesome-icon icon="angle-double-right" />
                  </b-button>
                </b-button-group>
                <b-button 
                  class="ml-2" 
                  @click="$event => showDate=new Date()"
                >
                  Vandaag
                </b-button>
                <div class="text-lg p-2">
                  van {{ moment(headerProps.periodStart).format('LL') }} t/m {{ moment(headerProps.periodEnd).format('LL') }}
                </div>
              </b-button-toolbar>
            </template> 
          </calendar-view>

          <b-button-toolbar class="mb-3">
            <b-button-group>
              <b-form-input 
                v-model="filter" 
                type="search" 
                size="lg" 
                placeholder="Zoeken..."
              />
            </b-button-group>
          </b-button-toolbar>
          <b-table 
            v-if="!isAuditTabSelected"
            :busy="busy"
            :filter="filter"
            :items="filteredTodos"
            :fields="['Omschrijving','Status','Unit','Relatie',{key:'DatumKolom',label: status == 'Openstaand' ? 'Uitvoeren voor' : 'Ingepland op', },'Audit','Actie']"
            dark
            bordered
            primary-key="data.id"
          >
            <template #table-busy>
              <div class="text-center text-white my-2">
                <b-spinner class="align-middle mx-2" />
                <strong>Laden...</strong>
              </div>
            </template>

            <template #row-details="row">
              <b-list-group 
                v-if="row.item.data.valt_onder.detail" 
                small
              >
                <b-list-group-item 
                  v-for="(i,key) in row.item.data.valt_onder.detail"
                  :key="key" 
                >
                  {{ key }}: 
                  <ResourceDownload 
                    v-if="i.secure_url" 
                    :doc="i"
                  />
                  <span v-else>{{ i }}</span>
                </b-list-group-item>
              </b-list-group>
            </template>

            <template #cell(Relatie)="row">
              {{ row.item.data.valt_onder.relatie ? row.item.data.valt_onder.relatie.Naam : 'Geen relatie' }} 
              <b-badge variant="primary">
                id.{{ row.item.data.id }}
              </b-badge>

              {{ row.item.data.valt_onder.type }} 
            </template>
            <template #cell(Status)="row">
              <font-awesome-icon 
                v-if="row.item.data.status === 'OPEN'" 
                icon="square"
              />
              <font-awesome-icon 
                v-if="row.item.data.status === 'AUDIT'" 
                icon="check"
              />
              {{ row.item.data.status }}
            </template>
            <template #cell(Audit)="row">
              {{ row.item.data.gecontroleerd_door ? row.item.data.gecontroleerd_door.Naam : '-' }}
            </template>

            <template 
              #cell(DatumKolom)="row" 
            >
              <span v-if="row.item.data.datum == null">
                {{ moment(row.item.data.deadline).fromNow() }}
              </span>
              <span v-else>
                {{ moment(row.item.data.datum).format('L') }}
              </span>
            </template>
           
            <template #cell(Unit)="row">
              <span v-if="row.item.data.unit">
                <b-link :to="{name: 'UnitViewRoute',params: {id: row.item.data.unit.id}}">{{ row.item.data.unit.unitkenmerk }} {{ row.item.data.unit.adres }} {{ row.item.data.unit.wijk_plaats }}</b-link>
              </span>
            </template>

            <template #cell(Actie)="row">
              <b-button 
                v-if="row.item.data.datum == null"
                block
                @click="plantaak(row.item)"
              >
                <font-awesome-icon icon="calendar" /> uitvoering op
              </b-button>
              
              <b-button 
                v-else-if="row.item.data.status == 'OPEN'" 
                variant="success" 
                block
                @click="uitvoeringTaak(row.item)"
              >
                <font-awesome-icon icon="check" /> status bewerken
              </b-button>
              
              <span v-else-if="row.item.audit_link != null">
                <b-button @click="$router.push(row.item.audit_link)">
                  Naar {{ row.item.audit_link.name }}
                </b-button>
              </span>
            </template>

            <template #cell(Omschrijving)="row">
              <b-form-checkbox
                v-model="row.detailsShowing"
                switch
                @change="row.toggleDetails"
              >
                {{ row.item.titel }}<br>
                <b-badge>{{ row.item.data.valt_onder ? row.item.data.valt_onder.titel : row.item.titel }}</b-badge>
              </b-form-checkbox>
            </template>
          </b-table>
          <accordering-taken 
            v-else 
            :filter="filter"
          />
        </b-card-body>
      </b-card>
    </b-col>

    <b-modal 
      v-if="todo != null" 
      v-model="showPlanner"
      title="Inplannen" 
      @hide="todo = null" 
      @ok="() => updateTrajectTaak(todo.data.url + 'planning', {payload:todo})"
    >
      <b-input-group prepend="Wanneer">
        <b-form-datepicker 
          v-model="todo.data.datum" 
          selected-variant="dark"
        />
      </b-input-group>
    </b-modal>

    <b-modal
      v-if="done != null"
      v-model="showStatus"
      :ok-disabled="(done.data.inspectie == null && isInspectie(done) && done.data.voltooid)"
      title="Status bewerken"
      @hide="done = null"
      @ok="() => updateTrajectTaak(done.data.url + 'uitvoering', {payload: done}).then(resp => {
        updateInTodoList(resp.data.taak);
      })"
    >
      <component 
        :is="done.data.type" 
        :done="done"
        :inspecties="inspecties"
      />
    </b-modal>

    <b-col md="5">
      <b-card-title>Recente logboek berichten </b-card-title>
      <RecenteBerichten />
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues
import { serviceMixin } from "@/mixins/serviceMixin";
import { verkoopMixin } from "@/mixins/verkoopMixin";
import Vue from "vue";
import HelpFiles from "@/components/HelpFiles";
import { Doughnut } from "vue-chartjs";
import FontAwesome from './icons/FontAwesome.vue';
import  CalendarView from "vue-simple-calendar"
import CalendarMathMixin from "vue-simple-calendar/dist/calendar-math-mixin.js"
import "vue-simple-calendar/dist/static/css/default.css"
import "vue-simple-calendar/dist/static/css/holidays-us.css"

/* TODO COMPONENTS */
import NulInspectie from "@/components/operationeel/Todo.vue";
import Herinspectie from "@/components/operationeel/Todo.vue";
import Standaard from "@/components/operationeel/Todo.vue";
import  Uitvoering  from "@/components/operationeel/Todo.vue";
import  Algemeen  from "@/components/operationeel/Todo.vue";
import  Unit  from "@/components/operationeel/Todo.vue";
import AccorderingTaken from './administratie/AccorderingTaken.vue';
import ResourceDownload from '@/components/cloudinary/ResourceDownload.vue';
import RecenteBerichten from '../components/logboek/RecenteBerichten.vue';

Vue.component("GmapCluster", GmapCluster);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD_4rUOZqGycAWSeT6ctkCKnbL6z6whrX8"
  }
});

export default {
  components: {
    HelpFiles,
    Doughnut,
    FontAwesome,
    NulInspectie,
    Herinspectie,
    Standaard,
    Uitvoering,
    Algemeen,
    Unit,
    AccorderingTaken,
    ResourceDownload,
    CalendarView,
    RecenteBerichten
},
  mixins: [ serviceMixin, verkoopMixin, CalendarMathMixin],
  data() {
    return {
      status: 'Openstaand',
      todo: null, 
      done: null,
      calenderOptions: {
        displayPeriod: 'week',
        displayPeriodCount: 2,
        useDefaultTheme: true,
        useHolidayTheme: true,
      },
      showDate: new Date(),
      showPlanner: false,
      showStatus: false,
      todos: [],
      busy: false,
      inspecties: [],
      verbruik: {},
      center: { lat: 51.9875387, lng: 4.2564107 },
      units: [],
      infoContent: "",
      infoLink: "",
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      filter: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },
  computed: {
    themeClasses() {
        return {
          "theme-default": this.calenderOptions.useDefaultTheme,
          "holiday-us-traditional": this.calenderOptions.useHolidayTheme,
          "holiday-us-official": this.calenderOptions.useHolidayTheme,
        }
      },
    filters: function () {
      return [
        {
          icon: 'new',
          label: 'Openstaand',
          show: true,
          filter: (o) => o.data.datum == null
        },
        {
          icon: 'calendar',
          label: 'Gepland',
          show: true,
          filter: (o) => o.data.datum != null && o.data.status == 'OPEN'
        },
        {
          icon: 'check',
          label: 'Voltooid',
          show: true,
          filter: (o) => o.data.status == 'AUDIT'
        },
        {
          icon: "history",
          label: 'Historie',
          show: true,
          filter: (o) => o.data.status == 'CLOSED'
        },
        {
          icon: "thumbs-up",
          label: 'Accordering',
          show: this.showAuditTab,
          filter: () => false
        }
      ]
    },
    planningItems: function () {
      return this.todos.filter(this.filters.find(f => f.label == "Gepland").filter).map(i => {
        return {
          id: i.data.id,
          startDate: i.data.datum,
          endDate: i.data.datum,
          title: `${i.titel} (${i.data.valt_onder.titel})`
        }
      })
    },
    filteredTodos: function () {
      return this.todos.filter(this.filters.find(f => f.label == this.status).filter)
    },
    showAuditTab: function () {
      // return this.$store.state.user.roles.includes('Beheerder')
      return true
    },
    isPlanningTabSelected: function () {
      return this.status == "Gepland"
    },
    isAuditTabSelected: function () {
      return this.status == this.filters[this.filters.length-1].label
    },
    unitMarkers: function() {
      var result = [];
      for (var u of this.units) {
        if (u.Lo[0] != "" && u.Lo[1] != "") {
          result.push({
            position: { lat: u.Lo[0] , lng:u.Lo[1]},
            label: "S",
            draggable: false,
            title: u.Ti,
            info: u
          });
        }
      }
      return result;
    }
  },
  mounted() {
    // this.getUnits();
    // this.getUsage();
    this.getTodo();
  },
  methods: {
    setShowDate(d) {
      this.showDate = d;
    },
    addDateWeek(i) {
      var d = moment(this.showDate).add(i, 'weeks').toDate();
      this.showDate = d;
    },
    plantaak(taak) {
      this.todo = {...taak}
      this.showPlanner = true
    },
    updateInTodoList(taak) {
      var index = this.todos.map(d => d.data.id).indexOf(taak.data.id)
      console.log(index) 
      this.$set(this.todos,index,taak);
    },
    uitvoeringTaak(taak) {
      this.done = {...taak}
      this.showStatus = true
    },
    isInspectie: function (d) {
        if (d.data.type == 'NulInspectie') return true;
        if (d.data.type == 'Herinspectie') return true;
        return false
      },
    getUsage() {
      var vm = this;
      this.isBusy = true;
      this.$http
        .get("/media/cloudinary/usage", {
          headers: {
            token: vm.$store.state.token
          }
        })
        .then(function(response) {
          console.log(response.data);
          vm.verbruik = response.data;
        })
        .catch(function(error) {
          console.log(error);
        })
        .then(function() {
          vm.isBusy = false;
        });
    },
    getTodo() {
      var vm = this;
      this.busy = true;
      this.get("/user/profile/todo").then((resp) => {
        this.inspecties = resp.data.inspecties
        this.todos = resp.data.events
      }).finally(() => { vm.busy = false });
      //this.getEndpoint('/user/profile/todo',this,'todo','events');
    },
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.info;
      this.infoLink = marker.www;
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.currentMidx = idx;
        this.infoWinOpen = true;
      }
    },
    getUnits() {
      var vm = this;
      this.isBusy = true;
      this.$http
        .get("/units/zoeken/1", {
          headers: {
            token: vm.$store.state.token
          },
          onDownloadProgress: function(progressEvent) {
            console.log("download", progressEvent);
          }
        })
        .then(function(response) {
          console.log(response.data.units.length);
          vm.units = response.data.units;
          vm.isBusy = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
  @import '../assets/scss/style';
  #calendar {
    color: $body-color;
    height: 63vh;
    margin-left: auto;
    margin-right: auto;
  }
  .theme-default .cv-event {
    background-color: $secondary;
    border-color: $table-border-color;
    color: $body-color;
  }
  .theme-default .cv-event.success {
    background-color: $success;
    border-color: lighten($success, 5%);
  }
  .theme-default .cv-event.danger {
    background-color: $danger;
  }
  .theme-default .cv-event.primary {
    background-color: $primary;
  }
  .theme-default .cv-event.orange {
    background-color: $orange;
    border-color: lighten($orange, 5%);
  }
  .theme-default .cv-day.today {
    background-color: $gray-300;
  }
  .theme-default .cv-day.today > .cv-day-number {
    background-color: $blue;
    border-radius: 50%;
  }
  .theme-default .cv-day.past {
     background-color: $body-bg;
  }
  .theme-default .cv-day.outsideOfMonth {
     background-color: $body-bg;
  }
  .theme-default .cv-weeks,
  .theme-default .cv-day {
    border-color: $table-border-color;
  }
  .theme-default .cv-header,
  .theme-default .cv-header-days,
  .theme-default .cv-header-day {
    background-color: $table-head-bg;
    border-color: $table-border-color;
  }
  .theme-default .cv-header-nav > button {
    color: $body-color;
    background-color: $input-bg;
    border-color: $input-border-color;
  }
  .theme-default .cv-day.draghover {
    box-shadow: inset 0 0 0.2em 0.2em $sidebar-nav-link-hover-bg;
  }
</style>
